// extracted by mini-css-extract-plugin
export default {"header-svg-icon-container":"root_svg-icon-module__header-svg-icon-container___RKtBM","headerSvgIconContainer":"root_svg-icon-module__header-svg-icon-container___RKtBM"};